import axios from 'axios';

import { getAccessToken } from '@/utils/auth';

export default () => {
	var jwtToken = getAccessToken();
	if (!jwtToken) {
		return Promise.reject('No JWT token!');
	}
	const USERINFO_URL = `https://${process.env.VUE_APP_COGNITO_APP_DOMAIN}/oauth2/userInfo`;
	var requestData = {
		headers: {
			Authorization: 'Bearer ' + jwtToken
		}
	};
	return axios.get(USERINFO_URL, requestData);
};
